import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { AppContext } from "../../store/AppContext";

export default function SimpleBackdrop() {
  const { loader } = React.useContext(AppContext);
  return (
    <div style={{ zIndex: "10000000", position: "fixed" }}>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
